/**
 *
 */
export enum TenancyDuration {
  ThreeMonths = 1,
  SixMonths = 2,
  OneYear = 3,
  TwoYearOrMore = 4,
}
